// API Configuration
// Uses environment variables with fallback to production
// If VITE_API_BASE_URL is not set, defaults to https://api.tilliopayment.com
const DEFAULT_API_URL = 'https://api.tilliopayment.com'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || DEFAULT_API_URL

export const API_ENDPOINTS = {
    onboarding: `${API_BASE_URL}/api/onboarding/interest`,
}
